import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const CopyTicket = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 16}
        height={size ?? 16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6667 8.6V11.4C10.6667 13.7333 9.73333 14.6667 7.4 14.6667H4.6C2.26666 14.6667 1.33333 13.7333 1.33333 11.4V8.6C1.33333 6.26667 2.26666 5.33333 4.6 5.33333H7.4C9.73333 5.33333 10.6667 6.26667 10.6667 8.6Z"
          fill={color}
        />
        <path
          d="M11.4 1.33333H8.6C6.6793 1.33333 5.71167 1.97026 5.42923 3.4926C5.32764 4.04017 5.79499 4.5 6.3519 4.5H7.4C10.2 4.5 11.5 5.8 11.5 8.6V9.6481C11.5 10.205 11.9598 10.6724 12.5074 10.5708C14.0297 10.2883 14.6667 9.3207 14.6667 7.4V4.6C14.6667 2.26667 13.7333 1.33333 11.4 1.33333Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default CopyTicket;
